import { composeClassNames } from "@faedev/editor-utils";
import { CSSProperties } from "react";
import Lottie from "react-lottie";
import Heading from "src/components/Heading";
import Translate from "src/components/Translate";
import constants from "src/constants";
import * as lottieEducation from "src/icons/Lottie-education.json";
import * as lottieFinance from "src/icons/Lottie-finance.json";
import * as lottieMarketing from "src/icons/Lottie-marketing.json";
import { sGroupTitle } from "src/styles/sGroupTitle.module.scss";
import { sPlatformCard } from "src/styles/sPlatformCard.module.scss";

type Props = {
  style?: CSSProperties | null | undefined;
  className?: (string | string) | null | undefined;
};

function PlatformCardsInstructors({ style, className }: Props) {
  return (
    <div
      className={composeClassNames([
        sPlatformCard,
        className,
        "platform-cards",
      ])}
      style={style}
    >
      <div className="platform-card">
        <div className="platform-card-lottie">
          <Lottie
            options={{
              ...constants.Images.lottieDefaultOptions,
              animationData: lottieMarketing,
            }}
            width={300}
            height={240}
          />
        </div>
        <div className="platform-card-text">
          <Heading
            type="h3"
            title={<Translate tKey={`Technological and marketing support`} />}
            className={composeClassNames([sGroupTitle, "platform-card-title"])}
          />
          <p>
            <Translate
              tKey={`Need to rent or buy video recording equipment or find a meaningful strategy for social media success? We will provide the technology, arrange sponsorship and marketing contracts and other essentials that will allow you to shine.`}
            />
          </p>
        </div>
      </div>
      <div className="platform-card">
        <div className="platform-card-lottie">
          <Lottie
            options={{
              ...constants.Images.lottieDefaultOptions,
              animationData: lottieEducation,
            }}
            width={300}
            height={240}
          />
        </div>
        <div className="platform-card-text">
          <Heading
            type="h3"
            title={<Translate tKey={`Education and information`} />}
            className={composeClassNames([sGroupTitle, "platform-card-title"])}
          />
          <p>
            <Translate
              tKey={`We organize trainings, bring news from the world of yoga and exercise, and inform you about innovations in the field of technology and business. With us, thanks to continuous education, you will always be one step ahead, equipped with knowledge and self-confidence.`}
            />
          </p>
        </div>
      </div>
      <div className="platform-card">
        <div className="platform-card-lottie">
          <Lottie
            options={{
              ...constants.Images.lottieDefaultOptions,
              animationData: lottieFinance,
            }}
            width={300}
            height={240}
          />
        </div>
        <div className="platform-card-text">
          <Heading
            type="h3"
            title={<Translate tKey={`Fair conditions and finance`} />}
            className={composeClassNames([sGroupTitle, "platform-card-title"])}
          />
          <p>
            <Translate
              tKey={`We take a fair approach to our community members and support tutors and their work. For your work as an author, you will receive a full 70 to 81% of the price paid by users, i.e. the majority of the total amount. Simply and without unnecessary bureaucracy.`}
            />
          </p>
        </div>
      </div>
    </div>
  );
}

export default PlatformCardsInstructors;
